import React from "react";
import {RoleNameEnum} from "../../../utils/types/common";
import {DropdownMenu, DropdownMenuItem} from "@reside/ui";
import {AdministrationMenuDropdownButton} from "./AdministrationMenuDropdownButton";
import {resideAdminTabs, getAdministrationMenuTabs} from "./constants";
import {ResideAdminTabsSeparator} from "./ResideAdminTabsSeparator";
import {AdministrationMenuProps} from "../types";
import {AdminRoles} from "../../admin-roles";

/** Administration-related tabs. */
export const AdministrationMenu = ({
  role,
  firstFacilityId,
}: AdministrationMenuProps): JSX.Element => {
  const administrationMenuTabs = getAdministrationMenuTabs(firstFacilityId);

  return (
    <DropdownMenu
      trigger={(open: boolean) => (
        <AdministrationMenuDropdownButton open={open} />
      )}
    >
      {administrationMenuTabs
        .filter(tab => tab.roles.includes(role)) // Only show tabs that the user has access to.
        .map(tab => {
          return (
            <DropdownMenuItem
              asLink
              disabled={tab?.disabled}
              key={tab.id}
              to={tab.link}
              data-test-id={tab.id}
            >
              {tab.name}
            </DropdownMenuItem>
          );
        })}

      <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
        <ResideAdminTabsSeparator />

        {resideAdminTabs.map(tab => {
          return (
            <DropdownMenuItem
              key={tab.id}
              to={tab.link}
              data-test-id={tab.id}
              asLink
            >
              {tab.name}
            </DropdownMenuItem>
          );
        })}
      </AdminRoles>
    </DropdownMenu>
  );
};
